/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@material-ui/core';
import { DateHelper } from '../../helpers/DateHelper';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';

const _ = require('underscore');

class FetaureUsage extends PureComponent {
    paramsParser = () => {
        const { params } = this.props;
        let mainName = null;
        let value = null;
        let createdAt = null;
        let updatedAt = null;
        const storeObject = {};
        let isUsage = false;

        for (let i = 0; i < params.length; i++) {
            mainName = params[i].mainname;
            value = params[i].value;
            createdAt = params[i].createdAt;
            updatedAt = params[i].updatedAt;

            if (mainName === 'service_usage' && value !== '[]') {
                value = JSON.parse(value);
                isUsage = true;
            }
            if (updatedAt === null) {
                updatedAt = createdAt;
            }

            storeObject[mainName] = value;
            storeObject['updatedAt'] = updatedAt;
        }
        if (isUsage) {
            return storeObject;
        }
        return null;
    };

    render() {
        const { classes } = this.props;
        const tableCellRoot = { root: classes.tableCellRoot };
        const params = this.paramsParser();
        const f = 3;
        const s = 9;
        if (params) {
            return (
                <TableRow hover={true}>
                    <TableCell classes={tableCellRoot} padding="none" align="right" />
                    <TableCell classes={tableCellRoot} padding="none" align="left" colSpan={3}>
                        <GridContainer>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.validFrom" />
                            </GridItem>
                            <GridItem xs={f}>{DateHelper.format(params.datesubscriptionfeepaid)}</GridItem>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.validTo" />
                            </GridItem>
                            <GridItem xs={f}>{DateHelper.format(params.datesubscriptionfeeexpiry)}</GridItem>

                            {params.service_usage.map((row) => (
                                <React.Fragment key={'usage' + row.featureid}>
                                    <GridItem xs={f} style={{ marginTop: '10px' }}>
                                        <I18n trans="simcard:f.usageName" />
                                    </GridItem>
                                    <GridItem xs={s} style={{ marginTop: '10px' }}>
                                        {row.featurename}
                                    </GridItem>

                                    <GridItem xs={f}>
                                        <I18n trans="simcard:f.usageUpdated" />
                                    </GridItem>
                                    <GridItem xs={s}>{DateHelper.format(params.updatedAt)}</GridItem>
                                    {row.initialunits && (
                                        <React.Fragment>
                                            <GridItem xs={f}>
                                                <I18n trans="simcard:f.initialSize" />
                                            </GridItem>
                                            <GridItem xs={s}>
                                                {row.initialunits} {row.unitofmeasure}
                                            </GridItem>
                                        </React.Fragment>
                                    )}
                                    {_.has(row, 'remainingunits') && (
                                        <React.Fragment>
                                            <GridItem xs={f}>
                                                <I18n trans="simcard:f.usageSize" />
                                            </GridItem>
                                            <GridItem xs={s}>
                                                {row.remainingunits} {row.unitofmeasure}
                                            </GridItem>
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            ))}
                        </GridContainer>
                    </TableCell>
                </TableRow>
            );
        }
        return null;
    }
}

FetaureUsage.propTypes = {
    classes: PropTypes.object.isRequired,
    params: PropTypes.array.isRequired,
};

export default withStyles(adescomStyle)(FetaureUsage);
